import BaseCreatableSelect from '@Components/Form/BaseCreatableSelect/BaseCreatableSelect'
import BaseSearch from '@Components/Form/BaseSearch/BaseSearch'
import BasePagination, {
    IBasePaginationEvent,
} from '@Components/table/BasePagination/BasePagination'
import BaseTable from '@Components/table/BaseTable/BaseTable'
import { EAuthReground } from '@Enum/auth.enum'
import useSearch from '@Hooks/useSearch'
import { MCity, MCountry, MState } from '@Models/auth.model'
import { ICommonQuery, IMetaData, ITableHeaders } from '@Models/common.model'
import { MReportUser } from '@Models/Report/users.model'
import { Grid } from '@mui/material'
import { APIServices } from '@Services/api.service'
import AuthAction from '@Stores/auth/auth.action'
import UserReportActions from '@Stores/report/actions/user-report.action'
import axios from 'axios'
import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router'
import * as Redux from 'redux'
import './Report.scss'

const headers: ITableHeaders[] = [
    {
        name: 'No',
        key: 'no',
        formatType: 'no',
    },
    {
        name: 'First Name',
        key: 'firstName',
    },
    {
        name: 'Middle Name',
        key: 'middleName',
    },
    {
        name: 'Last Name',
        key: 'lastName',
    },
    {
        name: 'Sex',
        key: 'gender',
    },
    {
        name: 'Email',
        key: 'email',
    },
    {
        name: 'Telephone',
        key: 'phone',
    },
    {
        name: 'Address',
        key: 'address',
    },
]

interface IReport {
    // redux
    getReground: (type: string, parentId: string, stepTwo?: string) => void
    clearReground: (types: string[]) => void
    getUsers: () => void
    setQueries: (params: ICommonQuery) => void
    getPublicToken: () => Promise<any>
    getAuthorization: () => Promise<any>
    countries: MCountry[]
    states: MState[]
    cities: MCity[]
    publicToken: string
    users: MReportUser[]
    userMetadata: IMetaData
    userLoading: boolean
    userQueries: ICommonQuery
}

const Report = (props: IReport) => {
    const {
        getReground,
        clearReground,
        getUsers,
        setQueries,
        getAuthorization,
        getPublicToken,
        countries,
        states,
        cities,
        publicToken,
        users,
        userMetadata,
        userLoading,
        userQueries,
    } = props

    const history = useHistory()
    const [country, setCountry] = useState<any>()
    const [state, setState] = useState<any>()
    const [city, setCity] = useState<any>()
    const [search, setDebounceSearch] = useSearch('')

    useEffect(() => {
        // use this to remove Authorization field from the header request only this request
        delete axios.defaults.headers.common.Authorization

        if (publicToken) {
            getReground('COUNTRY', '')
        } else {
            getAuthorization().then(() => {
                getPublicToken().then(() => {
                    getReground('COUNTRY', '')
                })
            })
        }
        return () => {
            APIServices.axiosCancelToken()
        }
    }, [])

    // search user with debounce string
    useEffect(() => {
        setQueries({ search: search?.debounceString, offset: 0, page: 1 })
        getUsers()
        return () => {
            APIServices.axiosCancelToken()
        }
    }, [search?.debounceString])

    // functions section
    const handleSelectFilter = (e: string, type: string) => {
        // use this to remove Authorization field from the header request only this request
        delete axios.defaults.headers.common.Authorization

        const params = { offset: 0, page: 1 }
        switch (type) {
            case 'COUNTRY':
                setCountry(e)
                setState('')
                setCity('')
                clearReground([EAuthReground.STATES, EAuthReground.CITIES])
                setQueries({ country: e, state: '', city: '', ...params })
                if (e) getReground('STATE', e)
                break
            case 'STATE':
                setState(e)
                setCity('')
                clearReground([EAuthReground.CITIES])
                setQueries({ state: e, city: '', ...params })
                if (e) getReground('CITY', e)
                break
            case 'CITY':
                setCity(e)
                setQueries({ city: e, ...params })
                break
            default:
                break
        }
        getUsers()
    }

    const handlePageChange = (evt: IBasePaginationEvent) => {
        const { offset, limit, page } = evt

        setQueries({ limit, offset, page })
        getUsers()
    }

    const handleRowClicked = (evt: any) => {
        const id = evt?.data?.id
        history.push(`/admin/report/${id}`)
    }

    const handleSearch = (e: any) => {
        setDebounceSearch(e?.target?.value)
    }

    return (
        <div className="admin-report">
            <div className="report-section">
                <p className="page-title">User</p>
            </div>

            <div className="report-section">
                <div className="search-container">
                    <BaseSearch
                        placeholder="Search by Series number, SSN, First Name, Last Name, Email, Address, Zip, Firearm, Part, Accessory, Ammunition Series number"
                        value={search?.searchString}
                        onChange={handleSearch}
                    />
                </div>
                <Grid container spacing={2} className="mt-3 mb-1">
                    {/* <Grid
                        item
                        lg={6}
                        md={6}
                        sm={12}
                        xs={12}
                        className="pt-0 pb-2"
                    >
                        <BaseSearch
                            // eslint-disable-next-line max-len
                            placeholder="Search by Series number, SSN, First Name, Last Name, Email, Address, Zip, Firearm, Part, Accessory, Ammunition Series number"
                            value={search?.searchString}
                            onChange={handleSearch}
                        />
                    </Grid> */}
                    <Grid
                        item
                        lg={4}
                        md={6}
                        sm={12}
                        xs={12}
                        className="pt-0 pb-2"
                    >
                        <BaseCreatableSelect
                            label="Country"
                            className="mr-3"
                            fullWidth
                            options={countries}
                            value={country}
                            onChange={(e: any) =>
                                handleSelectFilter(e, 'COUNTRY')
                            }
                        />
                    </Grid>
                    <Grid
                        item
                        lg={4}
                        md={6}
                        sm={12}
                        xs={12}
                        className="pt-0 pb-2"
                    >
                        <BaseCreatableSelect
                            label="State"
                            className="mr-3"
                            fullWidth
                            options={states}
                            value={state}
                            onChange={(e: any) =>
                                handleSelectFilter(e, 'STATE')
                            }
                        />
                    </Grid>
                    <Grid
                        item
                        lg={4}
                        md={6}
                        sm={12}
                        xs={12}
                        className="pt-0 pb-2"
                    >
                        <BaseCreatableSelect
                            label="City"
                            className="mr-3"
                            fullWidth
                            options={cities}
                            value={city}
                            onChange={(e: any) => handleSelectFilter(e, 'CITY')}
                        />
                    </Grid>
                </Grid>
            </div>
            <BaseTable
                headers={headers}
                data={users}
                metadata={userMetadata}
                isLoading={userLoading}
                rowClickedAction={handleRowClicked}
            />
            <BasePagination
                currentPage={userQueries?.page}
                metadata={userMetadata}
                pageChanged={handlePageChange}
            />
        </div>
    )
}

// store section
const mapStateToProps = (state: any) => {
    const { countries, states, cities } = state?.tempAuth
    const publicToken = state?.auth?.publicToken
    const { users, userMetadata, userLoading, userQueries } =
        state?.report?.users

    return {
        countries,
        states,
        cities,
        publicToken,
        users,
        userMetadata,
        userLoading,
        userQueries,
    }
}

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    const { getReground, clearReground, getPublicToken, getAuthorization } =
        AuthAction
    const { getUsers, setUsersQueries } = UserReportActions

    return {
        getReground: (type: string, parentId: string, stepTwo?: string) =>
            dispatch(getReground(type, parentId, stepTwo) as any),
        clearReground: (types: string[]) =>
            dispatch(clearReground(types) as any),
        getUsers: () => dispatch(getUsers() as any),
        setQueries: (params: ICommonQuery) =>
            dispatch(setUsersQueries(params) as any),
        getPublicToken: () => dispatch(getPublicToken() as any),
        getAuthorization: () => dispatch(getAuthorization() as any),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Report)
